/**
 * Utility functions for handling dynamic series fallback logic
 */

/**
 * Gets the effective value for a dynamic series key field, with fallback support
 * @param {Object} dataItem - The data item to extract the key from
 * @param {string} keyField - The primary key field name
 * @returns {string|null} - The effective key value (with parentheses for fallbacks)
 */
export const getEffectiveKeyValue = (dataItem, keyField) => {
  const primaryValue = dataItem[keyField];
  
  // If primary field is null/undefined/empty, try fallback field
  if (primaryValue === null || primaryValue === undefined || 
      (typeof primaryValue === 'string' && primaryValue.trim() === '')) {
    // Try fallback field (e.g., siteAssetReference when siteAssetName is null)
    const fallbackField = keyField === 'siteAssetName' ? 'siteAssetReference' : null;
    const fallbackValue = fallbackField ? dataItem[fallbackField] : primaryValue;
    // Add parentheses around fallback values to distinguish them
    return fallbackValue ? `(${fallbackValue})` : primaryValue;
  }
  
  return primaryValue;
};

/**
 * Checks if a data item matches a series key value, considering fallback logic
 * @param {Object} dataItem - The data item to check
 * @param {string} keyField - The key field name
 * @param {string} keyValue - The series key value to match against
 * @returns {boolean} - Whether the item matches the series
 */
export const doesItemMatchSeriesKey = (dataItem, keyField, keyValue) => {
  const effectiveValue = getEffectiveKeyValue(dataItem, keyField);
  return effectiveValue === keyValue;
};
